import { AngularEditorConfig } from '@kolkov/angular-editor';

export const RICHTEXT_EDITOR_CONFIG: AngularEditorConfig = {
  editable: true,
  spellcheck: true,
  height: '10rem',
  minHeight: '5rem',
  placeholder: 'Enter text here...',
  translate: 'no',
  defaultParagraphSeparator: 'p',
  defaultFontName: 'Roboto',
  defaultFontSize: '2',
  fonts: [
    { class: 'arial', name: 'Arial' },
    { class: 'times-new-roman', name: 'Times New Roman' },
    { class: 'calibri', name: 'Calibri' },
    { class: 'comic-sans-ms', name: 'Comic Sans MS' },
    {class:'roboto', name:'Roboto' }
  ],
  customClasses: [
    {
      name: 'redText',
      class: 'redText'
    },
    {
      name: 'titleText',
      class: 'titleText',
      tag: 'h1'
    }
  ],
  sanitize: false,
  toolbarPosition: 'bottom',
  toolbarHiddenButtons: [
    ['undo',
    'redo',
    'indent', 'outdent', 'insertUnorderedList', 'insertOrderedList', 'heading'],
    [
      'customClasses',
      // 'link',
      // 'unlink',
      'insertImage',
      'insertVideo',
      // 'insertHorizontalRule',
      // 'removeFormat',
      'toggleEditorMode'
    ]
  ]
};
